import { dramas } from "@/mocks/dramas";
import SectionHeading from "@/pages/home/components/SectionHeading";
import Reveal from "@/components/feature/Reveal";

export default function LatestUpdates() {
  const latest = [...dramas]
    .filter((d) => d.status === "热播中" || d.status === "最新更新")
    .sort((a, b) => (a.updateDate < b.updateDate ? 1 : -1));

  return (
    <section id="latest" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="Just Updated"
          title="最新韩剧更新"
          desc="按日期排列的更新动态，清晰标出每部剧当前更新到第几集。已完结的条目也会同步收录，方便你补齐近期错过的进度。"
        />

        <div className="mt-8 md:mt-10 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          <div className="hidden md:grid grid-cols-12 gap-4 px-6 py-3 bg-background-200/60 text-xs font-label uppercase tracking-wider text-foreground-600">
            <span className="col-span-5">剧集</span>
            <span className="col-span-2">题材</span>
            <span className="col-span-2">更新进度</span>
            <span className="col-span-2">类型</span>
            <span className="col-span-1 text-right">更新日</span>
          </div>

          <ul className="divide-y divide-background-200">
            {latest.map((drama, index) => (
              <Reveal as="li" key={drama.id} delay={Math.min(index, 5) * 50}>
                <div className="grid grid-cols-1 md:grid-cols-12 gap-3 md:gap-4 px-4 md:px-6 py-4 items-center hover:bg-primary-100/40 transition-colors">
                  <div className="col-span-5 flex items-center gap-3 min-w-0">
                    <span className="w-12 h-16 rounded-md overflow-hidden shrink-0 bg-background-200">
                      <img
                        src={drama.poster}
                        alt={`${drama.title} 韩剧海报缩略图`}
                        title={`${drama.title} 韩剧 最新更新`}
                        className="w-full h-full object-cover object-top"
                      />
                    </span>
                    <div className="min-w-0">
                      <p className="font-heading font-bold text-foreground-950 truncate">
                        {drama.title}
                      </p>
                      <p className="mt-1 text-xs font-label text-foreground-500">
                        {drama.year} · 共{drama.episodes}集 · 评分 {drama.score.toFixed(1)}
                      </p>
                    </div>
                  </div>

                  <div className="col-span-2 flex flex-wrap gap-1.5">
                    {drama.genres.map((g) => (
                      <span
                        key={g}
                        className="px-2 py-0.5 rounded-full text-xs font-label bg-secondary-100 text-secondary-900"
                      >
                        {g}
                      </span>
                    ))}
                  </div>

                  <div className="col-span-2">
                    <span className="inline-flex items-center gap-1.5 text-sm font-label text-primary-700">
                      <i className="ri-refresh-line" aria-hidden="true" />
                      {drama.updateNote}
                    </span>
                  </div>

                  <div className="col-span-2 text-sm font-label text-foreground-600">
                    {drama.status}
                  </div>

                  <div className="col-span-1 text-sm font-label text-foreground-500 md:text-right">
                    {drama.updateDate}
                  </div>
                </div>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}